module.exports = __webpack_public_path__ + "resources/img/img_blue_prism1_m_jp.c73704bb9f436d7cf73336d424efb94a.png";